import {Component} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {ForgotPwd} from "../../services/ForgotPwd";

@Component({
  selector: 'new-password',
  templateUrl: './new-pwd.html',
  viewProviders: [ForgotPwd]
})
export class NewPasswordCmp {
  public pwd:string = '';
  public isSet = false;
  public code:string = '';
  public error;
  public passwordRules = {
    minLength: false,
    hasLower: false,
    hasUpper: false,
    hasDigit: false,
    hasSpecial: false,
  };

  constructor(private router:Router, private params:ActivatedRoute, private forgotPwdService:ForgotPwd) {}

  ngOnInit() {
    this.params.params.subscribe(params => {
      this.init(params);
    });
  }

  init(params) {
    this.code = params["code"];
    if (!this.code) {
      this.router.navigate(['/forgot_pwd']);
      return;
    }
    this.forgotPwdService.checkCode(this.code).subscribe(()=> {}, ()=> {
      this.code = '';
      this.router.navigate(['/forgot_pwd']);
    });
  }

  onPasswordInput() {
    this.passwordRules.minLength = this.pwd.length >= 8;
    this.passwordRules.hasLower = /[a-z]/.test(this.pwd);
    this.passwordRules.hasUpper = /[A-Z]/.test(this.pwd);
    this.passwordRules.hasDigit = /[0-9]/.test(this.pwd);
    this.passwordRules.hasSpecial = /[^a-zA-Z0-9]/.test(this.pwd);
  }

  isPasswordValid():boolean {
    return this.passwordRules.minLength && this.passwordRules.hasLower &&
      this.passwordRules.hasUpper && this.passwordRules.hasDigit && this.passwordRules.hasSpecial;
  }

  setPwd() {
    if (!this.code || !this.pwd || !this.isPasswordValid()) {
      return;
    }
    this.forgotPwdService.setNewPassword(this.code, this.pwd).subscribe(()=> {
      this.isSet = true;
    }, (response)=> {
      this.error = response.status;
      console.error(response);
    });
  }
}
